/**
 * Errors a background refresh of a newly subscribed project may expect.
 *
 * A newer load for the same project aborts the older one and delivers the
 * data itself; auth gaps resolve on the next authenticated load. Neither is
 * a failed refresh.
 */
export function isExpectedSubscribedRefreshGap(error: unknown): boolean {
  const refreshError = error as { name?: string; message?: string; kind?: string; status?: number } | null;
  if (!refreshError) {
    return false;
  }
  return (
    refreshError.name === 'AbortError' ||
    refreshError.name === 'AuthSessionError' ||
    refreshError.kind === 'unauthorized' ||
    refreshError.kind === 'transient' ||
    refreshError.status === 401 ||
    refreshError.status === 403 ||
    /Authentication required|Session is no longer authorized|Refresh token is missing/i.test(refreshError.message || '')
  );
}
